// TODO: should be marked as server-only
// import 'server-only';
import { cache as memoizedCache } from 'react';
import { Locale } from '@headless-workspace/config';
import { FeatureFlagValue } from '@headless-workspace/core-domain';
import { CommonDI, StorageRepositoryType } from '../../../DI';

export const getMemoCountrySpecificitiesFeatureFlag = memoizedCache(
    async (locale: Locale, key: keyof FeatureFlagValue) => {
        const localeSpecificities = await CommonDI.get(StorageRepositoryType).getFeatureFlags(locale);

        return localeSpecificities.type === 'success' && localeSpecificities.data[key];
    },
);
